module.exports = __webpack_public_path__ + "media/images/index/product_line/car-3e02c6da9e9f764602fdac2e996378d4.svg";